<template>
  <div id="Report">

    <Head />
    <div class="report">
      <div class="leftNav">
        <decLeftNav ref="LeftNav" />
      </div>
      <main>
        <div class="edit">
          <div class="textNav">
            <div class="nTitle">目录</div>
            <ul>
              <!-- @click="getNav(index)" -->
              <li v-for="(item, index) in textNav" :key="index" :class="{ active: NavI == index }" @click="getNav(index)">
                {{ item }}
              </li>
            </ul>
          </div>
          <div class="container">
            <div class="content" v-if="NavI == 0">
              <p>成果概要</p>
              <div class="write">
                <p>说明： 500字以内</p>
                <wangEditor v-model="cggy" />
              </div>
              <p class="numbers">
                字数：
                <span>{{ cggy.replace(reg, "").length }}/500</span>
              </p>
            </div>
            <div class="content" v-if="NavI == 1">
              <p>企业简介</p>
              <div class="write">
                <p>
                  说明：
                  500字以内，主要反映单位所属行业、地区、产权性质、主要业务、规模、效益及行业地位等。
                </p>
                <wangEditor v-model="qyjj" />
              </div>
              <p class="numbers">
                字数：
                <span>{{ qyjj && qyjj.replace(reg, "").length }}/500</span>
              </p>
            </div>
            <div class="content" v-if="NavI == 2">
              <p>实施背景</p>
              <div class="write">
                <p>
                  说明：4000字以内，主要反映为什么实施本项管理创新，介绍在实施该项管理创新前存在什么问题和内外部环境发生哪些变化，以及实施该项管理创新期望达到的目标等。
                </p>
                <div class="info">
                  <div>
                    背景1：
                    <input type="text" v-model="infoSSBJ[0].title0" />
                  </div>
                  <wangEditor v-model="infoSSBJ[0].content0" class="e" />
                </div>
                <div class="info">
                  <div>
                    背景2：
                    <input type="text" v-model="infoSSBJ[1].title1" />
                  </div>
                  <wangEditor v-model="infoSSBJ[1].content1" class="e" />
                </div>
                <div class="info">
                  <div>
                    背景3：
                    <input type="text" v-model="infoSSBJ[2].title2" />
                  </div>
                  <wangEditor v-model="infoSSBJ[2].content2" class="e" />
                </div>
                <p class="numbers">
                  字数：
                  <span>{{
                    (
                      infoSSBJ[0].content0 +
                      infoSSBJ[1].content1 +
                      infoSSBJ[2].content2
                    ).replace(reg, "").length
                  }}/4000</span>
                </p>
              </div>
            </div>
            <div class="content" v-if="NavI == 3">
              <p>内涵</p>
              <div class="write">
                <p>
                  说明：1000字以内，概括介绍本项管理创新的基本内容，要求具有一定理论高度。
                </p>
                <wangEditor v-model="nh" />
              </div>
              <p class="numbers">
                字数：
                <span>{{ nh.replace(reg, "").length }}/1000</span>
              </p>
              <div class="pic">
                <p>图片上传：</p>
                <el-upload :action="$URL + 'upload/index?token=' + token" list-type="picture-card"
                  :headers="{ enctype: 'multipart/form-data' }" :data="{ upload_type: 'image' }"
                  :on-preview="handlePictureCardPreview" :on-remove="handleRemoveNH" :before-upload="beforeUpload"
                  :on-success="handleSuccessNH" :on-error="handleError" :limit="6" :file-list="fileListNH"
                  :on-exceed="handleExceed" accept=".jpg, .jpeg, .png">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
              </div>
            </div>
            <div class="content" v-if="NavI == 4">
              <p>主要做法</p>
              <div class="write">
                <p>
                  说明：10000字以内，报告的核心内容，应详细阐述实施本项管理创新的主要内容和具体措施，可辅以必要的实例、数据和图表予以说明。
                </p>
                <div class="info">
                  <div>
                    做法1：
                    <input type="text" v-model="infoZYZF[0].title0" />
                  </div>
                  <wangEditor v-model="infoZYZF[0].content0" class="e" />
                  <div class="pic">
                    <p>图片上传：</p>
                    <el-upload :action="$URL + 'upload/index?token=' + token" list-type="picture-card"
                      :headers="{ enctype: 'multipart/form-data' }" :data="{ upload_type: 'image' }"
                      :on-preview="handlePictureCardPreview" :on-remove="handleRemoveZF1" :on-success="handleSuccessZF1"
                      :before-upload="beforeUpload" :on-error="handleError" :limit="6" :file-list="fileListZF1"
                      :on-exceed="handleExceed" accept=".jpg, .jpeg, .png">
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                      <img width="100%" :src="dialogImageUrl" alt />
                    </el-dialog>
                  </div>
                </div>
                <div class="info">
                  <div>
                    做法2：
                    <input type="text" v-model="infoZYZF[1].title1" />
                  </div>
                  <wangEditor v-model="infoZYZF[1].content1" class="e" />
                  <div class="pic">
                    <p>图片上传：</p>
                    <el-upload :action="$URL + 'upload/index?token=' + token" list-type="picture-card"
                      :headers="{ enctype: 'multipart/form-data' }" :data="{ upload_type: 'image' }"
                      :on-preview="handlePictureCardPreview" :on-remove="handleRemoveZF2" :on-success="handleSuccessZF2"
                      :on-error="handleError" :before-upload="beforeUpload" :limit="6" :file-list="fileListZF2"
                      :on-exceed="handleExceed" accept=".jpg, .jpeg, .png">
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                      <img width="100%" :src="dialogImageUrl" alt />
                    </el-dialog>
                  </div>
                </div>
                <div class="info">
                  <div>
                    做法3：
                    <input type="text" v-model="infoZYZF[2].title2" />
                  </div>
                  <wangEditor v-model="infoZYZF[2].content2" class="e" />
                  <div class="pic">
                    <p>图片上传：</p>
                    <el-upload :action="$URL + 'upload/index?token=' + token" list-type="picture-card"
                      :headers="{ enctype: 'multipart/form-data' }" :data="{ upload_type: 'image' }"
                      :on-preview="handlePictureCardPreview" :on-remove="handleRemoveZF3" :on-success="handleSuccessZF3"
                      :on-error="handleError" :before-upload="beforeUpload" :limit="6" :file-list="fileListZF3"
                      :on-exceed="handleExceed" accept=".jpg, .jpeg, .png">
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                      <img width="100%" :src="dialogImageUrl" alt />
                    </el-dialog>
                  </div>
                </div>
                <div class="info">
                  <div>
                    做法4：
                    <input type="text" v-model="infoZYZF[3].title3" />
                  </div>
                  <wangEditor v-model="infoZYZF[3].content3" class="e" />
                  <div class="pic">
                    <p>图片上传：</p>
                    <el-upload :action="$URL + 'upload/index?token=' + token" list-type="picture-card"
                      :headers="{ enctype: 'multipart/form-data' }" :data="{ upload_type: 'image' }"
                      :on-preview="handlePictureCardPreview" :on-remove="handleRemoveZF4" :on-success="handleSuccessZF4"
                      :on-error="handleError" :before-upload="beforeUpload" :limit="6" :file-list="fileListZF4"
                      :on-exceed="handleExceed" accept=".jpg, .jpeg, .png">
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                      <img width="100%" :src="dialogImageUrl" alt />
                    </el-dialog>
                  </div>
                </div>
                <div class="info">
                  <div>
                    做法5：
                    <input type="text" v-model="infoZYZF[4].title4" />
                  </div>
                  <wangEditor v-model="infoZYZF[4].content4" class="e" />
                  <div class="pic">
                    <p>图片上传：</p>
                    <el-upload :action="$URL + 'upload/index?token=' + token" list-type="picture-card"
                      :headers="{ enctype: 'multipart/form-data' }" :data="{ upload_type: 'image' }"
                      :on-preview="handlePictureCardPreview" :on-remove="handleRemoveZF5" :on-success="handleSuccessZF5"
                      :on-error="handleError" :before-upload="beforeUpload" :limit="6" :file-list="fileListZF5"
                      :on-exceed="handleExceed" accept=".jpg, .jpeg, .png">
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                      <img width="100%" :src="dialogImageUrl" alt />
                    </el-dialog>
                  </div>
                </div>
                <div class="info">
                  <div>
                    做法6：
                    <input type="text" v-model="infoZYZF[5].title5" />
                  </div>
                  <wangEditor v-model="infoZYZF[5].content5" class="e" />
                  <div class="pic">
                    <p>图片上传：</p>
                    <el-upload :action="$URL + 'upload/index?token=' + token" list-type="picture-card"
                      :headers="{ enctype: 'multipart/form-data' }" :data="{ upload_type: 'image' }"
                      :on-preview="handlePictureCardPreview" :on-remove="handleRemoveZF6" :on-success="handleSuccessZF6"
                      :on-error="handleError" :before-upload="beforeUpload" :limit="6" :file-list="fileListZF6"
                      :on-exceed="handleExceed" accept=".jpg, .jpeg, .png">
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                      <img width="100%" :src="dialogImageUrl" alt />
                    </el-dialog>
                  </div>
                </div>
                <div class="info">
                  <div>
                    做法7：
                    <input type="text" v-model="infoZYZF[6].title6" />
                  </div>
                  <wangEditor v-model="infoZYZF[6].content6" class="e" />
                  <div class="pic">
                    <p>图片上传：</p>
                    <el-upload :action="$URL + 'upload/index?token=' + token" list-type="picture-card"
                      :headers="{ enctype: 'multipart/form-data' }" :data="{ upload_type: 'image' }"
                      :on-preview="handlePictureCardPreview" :on-remove="handleRemoveZF7" :on-success="handleSuccessZF7"
                      :on-error="handleError" :before-upload="beforeUpload" :limit="6" :file-list="fileListZF7"
                      :on-exceed="handleExceed" accept=".jpg, .jpeg, .png">
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                      <img width="100%" :src="dialogImageUrl" alt />
                    </el-dialog>
                  </div>
                </div>
                <p class="numbers">
                  字数：
                  <span>{{
                    (
                      infoZYZF[0].content0 +
                      infoZYZF[1].content1 +
                      infoZYZF[2].content2 +
                      infoZYZF[3].content3 +
                      infoZYZF[4].content4 +
                      infoZYZF[5].content5 +
                      infoZYZF[6].content6
                    ).replace(reg, "").length
                  }}/10000</span>
                </p>
              </div>
            </div>
            <div class="content" v-if="NavI == 5">
              <p>实施效果</p>
              <div class="write">
                <p>
                  说明：3000字以内，主要反映推进管理创新所发生的显著变化，包括经济效益、社会效益或直接效益、间接效益等内容。
                </p>
                <div class="info">
                  <div>
                    效果1：
                    <input type="text" v-model="infoSSXG[0].title0" />
                  </div>
                  <wangEditor v-model="infoSSXG[0].content0" class="e" />
                  <div class="pic">
                    <p>图片上传：</p>
                    <el-upload :action="$URL + 'upload/index?token=' + token" list-type="picture-card"
                      :headers="{ enctype: 'multipart/form-data' }" :data="{ upload_type: 'image' }"
                      :on-preview="handlePictureCardPreview" :on-remove="handleRemoveXG1" :on-success="handleSuccessXG1"
                      :on-error="handleError" :before-upload="beforeUpload" :limit="6" :file-list="fileListXG1"
                      :on-exceed="handleExceed" accept=".jpg, .jpeg, .png">
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                      <img width="100%" :src="dialogImageUrl" alt />
                    </el-dialog>
                  </div>
                </div>
                <div class="info">
                  <div>
                    效果2：
                    <input type="text" v-model="infoSSXG[1].title1" />
                  </div>
                  <wangEditor v-model="infoSSXG[1].content1" class="e" />
                  <div class="pic">
                    <p>图片上传：</p>
                    <el-upload :action="$URL + 'upload/index?token=' + token" list-type="picture-card"
                      :headers="{ enctype: 'multipart/form-data' }" :data="{ upload_type: 'image' }"
                      :on-preview="handlePictureCardPreview" :on-remove="handleRemoveXG2" :on-success="handleSuccessXG2"
                      :on-error="handleError" :before-upload="beforeUpload" :limit="6" :file-list="fileListXG2"
                      :on-exceed="handleExceed" accept=".jpg, .jpeg, .png">
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                      <img width="100%" :src="dialogImageUrl" alt />
                    </el-dialog>
                  </div>
                </div>
                <div class="info">
                  <div>
                    效果3：
                    <input type="text" v-model="infoSSXG[2].title2" />
                  </div>
                  <wangEditor v-model="infoSSXG[2].content2" class="e" />
                  <div class="pic">
                    <p>图片上传：</p>
                    <el-upload :action="$URL + 'upload/index?token=' + token" list-type="picture-card"
                      :headers="{ enctype: 'multipart/form-data' }" :data="{ upload_type: 'image' }"
                      :on-preview="handlePictureCardPreview" :on-remove="handleRemoveXG3" :on-success="handleSuccessXG3"
                      :on-error="handleError" :limit="6" :before-upload="beforeUpload" :file-list="fileListXG3"
                      :on-exceed="handleExceed" accept=".jpg, .jpeg, .png">
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                      <img width="100%" :src="dialogImageUrl" alt />
                    </el-dialog>
                  </div>
                </div>
                <div class="info">
                  <div>
                    效果4：
                    <input type="text" v-model="infoSSXG[3].title3" />
                  </div>
                  <wangEditor v-model="infoSSXG[3].content3" class="e" />
                  <div class="pic">
                    <p>图片上传：</p>
                    <el-upload :action="$URL + 'upload/index?token=' + token" list-type="picture-card"
                      :headers="{ enctype: 'multipart/form-data' }" :data="{ upload_type: 'image' }"
                      :on-preview="handlePictureCardPreview" :on-remove="handleRemoveXG4" :on-success="handleSuccessXG4"
                      :on-error="handleError" :before-upload="beforeUpload" :limit="6" :file-list="fileListXG4"
                      :on-exceed="handleExceed" accept=".jpg, .jpeg, .png">
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                      <img width="100%" :src="dialogImageUrl" alt />
                    </el-dialog>
                  </div>
                </div>
                <div class="info">
                  <div>
                    效果5：
                    <input type="text" v-model="infoSSXG[4].title4" />
                  </div>
                  <wangEditor v-model="infoSSXG[4].content4" class="e" />
                  <div class="pic">
                    <p>图片上传：</p>
                    <el-upload :action="$URL + 'upload/index?token=' + token" list-type="picture-card"
                      :headers="{ enctype: 'multipart/form-data' }" :data="{ upload_type: 'image' }"
                      :on-preview="handlePictureCardPreview" :on-remove="handleRemoveXG5" :on-success="handleSuccessXG5"
                      :on-error="handleError" :before-upload="beforeUpload" :limit="6" :file-list="fileListXG5"
                      :on-exceed="handleExceed" accept=".jpg, .jpeg, .png">
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                      <img width="100%" :src="dialogImageUrl" alt />
                    </el-dialog>
                  </div>
                </div>
                <p class="numbers">
                  字数：
                  <span>{{
                    (
                      infoSSXG[0].content0 +
                      infoSSXG[1].content1 +
                      infoSSXG[2].content2 +
                      infoSSXG[3].content3 +
                      infoSSXG[4].content4
                    ).replace(reg, "").length
                  }}/3000</span>
                </p>
              </div>
            </div>
            <div class="content" v-if="NavI == 6">
              <FullPreview :zbg="zbg" />
            </div>
            <div class="btn" v-if="NavI == 6">
              <div @click="upload">上传主报告</div>
            </div>
            <div v-else>
              <!-- <div class="btn" @click="next">{{NavI == 5&&NavI!=6 ? '保 存' : '下一页'}}</div> -->
              <div class="btn" @click="next" v-if="NavI != 4 && NavI != 5">
                保存
              </div>
              <div class="btn btn1" @click="next" v-else>保存</div>
              <div class="btn" @click="up" style="margin-right: 0.2rem" v-if="NavI != 4 && NavI != 5">
                {{ NavI == 0 && NavI != 6 ? "第一页" : "上一页" }}
              </div>
              <div class="btn btn1" @click="up" style="margin-right: 0.2rem" v-else>
                {{ NavI == 0 && NavI != 6 ? "第一页" : "上一页" }}
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
    <RightNav />
    <Foot />
  </div>
</template>
<script>
import Head from "@/components/Head";
import Foot from "@/components/Foot";
import decLeftNav from "@/components/decLeftNav";
import FullPreview from "./FullPreview";
import RightNav from "../../components/RightNav";
import wangEditor from "../../components/wangEnduit/wangEnduitReport";

export default {
  name: "Report",
  data() {
    return {
      ReportID: "",
      NavI: 0,
      reg: /<[^>]+>|&nbsp;/gi,
      textNav: [
        "成果概要",
        "企业简介",
        "一、实施背景",
        "二、内涵",
        "三、主要做法",
        "四、实施效果",
        "全文预览",
      ],
      zbg: "", //主报告id
      cggy: "",
      qyjj: "",
      stat: true,
      nh: "", //cgzbg_nh
      fileListNH: [],
      infoSSBJ: [
        { title0: "", content0: "" },
        { title1: "", content1: "" },
        { title2: "", content2: "" },
      ],
      infoZYZF: [
        { title0: "", content0: "" },
        { title1: "", content1: "" },
        { title2: "", content2: "" },
        { title3: "", content3: "" },
        { title4: "", content4: "" },
        { title5: "", content5: "" },
        { title6: "", content6: "" },
      ],
      fileListZF1: [],
      fileListZF2: [],
      fileListZF3: [],
      fileListZF4: [],
      fileListZF5: [],
      fileListZF6: [],
      fileListZF7: [],
      infoSSXG: [
        { title0: "", content0: "" },
        { title1: "", content1: "" },
        { title2: "", content2: "" },
        { title3: "", content3: "" },
        { title4: "", content4: "" },
      ],
      fileListXG1: [],
      fileListXG2: [],
      fileListXG3: [],
      fileListXG4: [],
      fileListXG5: [],
      dialogImageUrl: "",
      dialogVisible: false,
      token: "",
      imgQuality: 0.3,
      // qyjj1: "",
    };
  },
  components: {
    Head,
    Foot,
    decLeftNav,
    FullPreview,
    RightNav,
    wangEditor,
  },

  created() {
    window.scrollTo(0, sessionStorage.getItem("scroll"));
    this.token = sessionStorage.getItem("token");
  },
  mounted() {
    console.log(sessionStorage.getItem("name"), 55);
    if (!sessionStorage.getItem("name")) {
      this.$router.replace("/Declare");
    }
    console.log(sessionStorage.getItem("isTable"), 22);
    // this.$refs.LeftNav.isTable();
    if (sessionStorage.getItem("isListGo") == "true") {
      this.ReportID = sessionStorage.getItem("reportID");
    } else {
      this.ReportID = sessionStorage.getItem("ReportID");
    }
    if (this.$route.query.ReportID) {
      this.zbg = this.$route.query.ReportID;
    }
    this.getReportcontent();
    // this.getUser()
    //  this.loading11();
  },

  methods: {
    getUser() {
      this.$axios
        .post(
          "user/info",
          this.$qs.stringify({
            token: sessionStorage.getItem("token"),
            ID: JSON.parse(sessionStorage.getItem("userinfo")).ID,
          })
        )
        .then((res) => {
          console.log(res);
          if (res.data.code == 10000) {
            // this.qyjj1 = res.data.data;
            this.qyjj = res.data.data;
          }
        });
    },
    // loading11(val){
    //   console.log(val,6666)
    //   this.load=val
    // },
    // 导航栏点击
    dataURItoBlob(dataURI, type) {
      var binary = atob(dataURI.split(",")[1]);
      var array = [];
      for (var i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
      }
      return new Blob([new Uint8Array(array)], { type: type });
    },
    beforeUpload(param) {
      // console.log(file);
      //对图片进行压缩
      // console.log(param);
      const imgSize = param.size / 1024 / 1024;
      // console.log(imgSize);
      if (imgSize > 1) {
        const _this = this;

        return new Promise((resolve) => {
          const reader = new FileReader();
          const image = new Image();

          image.onload = (imageEvent) => {
            console.log(imageEvent);
            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            const width = image.width * _this.imgQuality;
            const height = image.height * _this.imgQuality;
            canvas.width = width;
            canvas.height = height;
            context.clearRect(0, 0, width, height);
            context.drawImage(image, 0, 0, width, height);
            const dataUrl = canvas.toDataURL(param.type);
            const blobData = _this.dataURItoBlob(dataUrl, param.type);

            resolve(blobData);
          };

          reader.onload = (e) => {
            image.src = e.target.result;
          };
          reader.readAsDataURL(param);
        });
      }
    },
    setContent(a) {
      console.log(a);
    },
    getNav(i) {
      this.NavI = i;
    },
    toObj2(key, val) {
      var data = { [key]: val };
      return data;
    },
    // 文件超出个数限制
    handleExceed() {
      // this.$message.warning(`当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      this.$message.warning("最多允许上传6张图片！");
    },
    // 内涵
    handleSuccessNH(res, file, fileList) {
      if (res.code == 10000) {
        this.$message({ message: res.msg, type: "success" });
        this.fileListNH = fileList;
        console.log(fileList, "nhsu");
      } else {
        this.$message.error(res.msg);
      }
    },
    // 做法
    handleSuccessZF1(res, file, fileList) {
      if (res.code == 10000) {
        console.log(res, "res做法1");
        this.$message({ message: res.msg, type: "success" });
        this.fileListZF1 = fileList;

        console.log(this.fileListZF1, "listZf1");
      } else {
        this.$message.error(res.msg);
      }
    },
    handleSuccessZF2(res, file, fileList) {
      if (res.code == 10000) {
        this.$message({ message: res.msg, type: "success" });
        this.fileListZF2 = fileList;
      } else {
        this.$message.error(res.msg);
      }
    },
    handleSuccessZF3(res, file, fileList) {
      if (res.code == 10000) {
        this.$message({ message: res.msg, type: "success" });
        this.fileListZF3 = fileList;
      } else {
        this.$message.error(res.msg);
      }
    },
    handleSuccessZF4(res, file, fileList) {
      if (res.code == 10000) {
        this.$message({ message: res.msg, type: "success" });
        this.fileListZF4 = fileList;
      } else {
        this.$message.error(res.msg);
      }
    },
    handleSuccessZF5(res, file, fileList) {
      if (res.code == 10000) {
        this.$message({ message: res.msg, type: "success" });
        this.fileListZF5 = fileList;
      } else {
        this.$message.error(res.msg);
      }
    },
    handleSuccessZF6(res, file, fileList) {
      if (res.code == 10000) {
        this.$message({ message: res.msg, type: "success" });
        this.fileListZF6 = fileList;
      } else {
        this.$message.error(res.msg);
      }
    },
    handleSuccessZF7(res, file, fileList) {
      if (res.code == 10000) {
        this.$message({ message: res.msg, type: "success" });
        this.fileListZF7 = fileList;
      } else {
        this.$message.error(res.msg);
      }
    },
    // 效果
    handleSuccessXG1(res, file, fileList) {
      console.log(fileList);
      if (res.code == 10000) {
        this.$message({ message: res.msg, type: "success" });
        this.fileListXG1 = fileList;
      } else {
        this.$message.error(res.msg);
      }
    },
    handleSuccessXG2(res, file, fileList) {
      if (res.code == 10000) {
        this.$message({ message: res.msg, type: "success" });
        this.fileListXG2 = fileList;
      } else {
        this.$message.error(res.msg);
      }
    },
    handleSuccessXG3(res, file, fileList) {
      if (res.code == 10000) {
        this.$message({ message: res.msg, type: "success" });
        this.fileListXG3 = fileList;
      } else {
        this.$message.error(res.msg);
      }
    },
    handleSuccessXG4(res, file, fileList) {
      if (res.code == 10000) {
        this.$message({ message: res.msg, type: "success" });
        this.fileListXG4 = fileList;
      } else {
        this.$message.error(res.msg);
      }
    },
    handleSuccessXG5(res, file, fileList) {
      if (res.code == 10000) {
        this.$message({ message: res.msg, type: "success" });
        this.fileListXG5 = fileList;
      } else {
        this.$message.error(res.msg);
      }
    },
    handleError(err) {
      if (err) {
        this.$message.error("图片上传失败");
      }
    },
    // 删除内涵
    handleRemoveNH(file, fileList) {
      this.fileListNH = fileList;
      console.log(this.fileListNH, "nn");
    },
    // 删除做法
    handleRemoveZF1(file, fileList) {
      this.fileListZF1 = fileList;
      console.log(this.fileListZF1, "listZF1");
    },
    handleRemoveZF2(file, fileList) {
      this.fileListZF2 = fileList;
    },
    handleRemoveZF3(file, fileList) {
      this.fileListZF3 = fileList;
    },
    handleRemoveZF4(file, fileList) {
      this.fileListZF4 = fileList;
    },
    handleRemoveZF5(file, fileList) {
      this.fileListZF5 = fileList;
    },
    handleRemoveZF6(file, fileList) {
      this.fileListZF6 = fileList;
    },
    handleRemoveZF7(file, fileList) {
      this.fileListZF7 = fileList;
    },
    // 删除效果
    handleRemoveXG1(file, fileList) {
      this.fileListXG1 = fileList;
      console.log(this.fileListXG1);
    },
    handleRemoveXG2(file, fileList) {
      this.fileListXG2 = fileList;
    },
    handleRemoveXG3(file, fileList) {
      this.fileListXG3 = fileList;
    },
    handleRemoveXG4(file, fileList) {
      this.fileListXG4 = fileList;
    },
    handleRemoveXG5(file, fileList) {
      this.fileListXG5 = fileList;
    },
    handlePictureCardPreview(file) {
      console.log(file, "picfile");
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //添加每项列表数据到接口
    addcontent(Title, Content) {
      let that = this;
      // console.log(Content);
      that.$axios.post(
        "reportcontent/save?Title=" +
        Title +
        "&ReportID=" +
        (that.zbg || that.ReportID) +
        "&token=" +
        sessionStorage.getItem("token"),
        that.$qs.stringify({ Content: Content })
      );
    },
    getReportcontent() {
      //获取预览内容
      var that = this;
      console.log(that.$route.query.ReportID, "ID");
      console.log(that.ReportID, "ID");
      that.$axios
        .post(
          "reportcontent/info?token=" + sessionStorage.getItem("token"),
          that.$qs.stringify({
            ReportID: that.$route.query.ReportID || that.ReportID,
            MouldID: "MD1",
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            console.log(res.data.data, "报告");
            this.contentInfo = res.data.data;
            if (this.contentInfo.length == 0) {
              this.getUser();
            }
            this.contentInfo.forEach((el) => {
              switch (el.Title) {
                case "cgzbg_cggy":
                  this.cggy = el.Content;
                  break;
                case "cgzbg_qyjj":
                  // this.qyjj = el.Content;
                  if (el.Content) {
                    this.qyjj = el.Content;
                  } else {
                    this.getUser();
                  }
                  break;
                case "cgzbg_ssbjbt1":
                  this.infoSSBJ[0].title0 = el.Content;
                  break;
                case "cgzbg_ssbjnr1":
                  this.infoSSBJ[0].content0 = el.Content;
                  break;
                case "cgzbg_ssbjbt2":
                  this.infoSSBJ[1].title1 = el.Content;
                  break;
                case "cgzbg_ssbjnr2":
                  this.infoSSBJ[1].content1 = el.Content;
                  break;
                case "cgzbg_ssbjbt3":
                  this.infoSSBJ[2].title2 = el.Content;
                  break;
                case "cgzbg_ssbjnr3":
                  this.infoSSBJ[2].content2 = el.Content;
                  break;
                case "cgzbg_nh":
                  this.nh = el.Content;
                  break;
                case "cgzbg_nhtp1":
                  if (el.Content) {
                    this.fileListNH.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_nhtp2":
                  if (el.Content) {
                    this.fileListNH.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_nhtp3":
                  if (el.Content) {
                    this.fileListNH.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_nhtp4":
                  if (el.Content) {
                    this.fileListNH.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_nhtp5":
                  if (el.Content) {
                    this.fileListNH.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_nhtp6":
                  if (el.Content) {
                    this.fileListNH.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzfbt1":
                  this.infoZYZF[0].title0 = el.Content;
                  break;
                case "cgzbg_zyzfnr1":
                  this.infoZYZF[0].content0 = el.Content;
                  break;
                case "cgzbg_zyzfbt2":
                  this.infoZYZF[1].title1 = el.Content;
                  break;
                case "cgzbg_zyzfnr2":
                  this.infoZYZF[1].content1 = el.Content;
                  break;
                case "cgzbg_zyzfbt3":
                  this.infoZYZF[2].title2 = el.Content;
                  break;
                case "cgzbg_zyzfnr3":
                  this.infoZYZF[2].content2 = el.Content;
                  break;
                case "cgzbg_zyzfbt4":
                  this.infoZYZF[3].title3 = el.Content;
                  break;
                case "cgzbg_zyzfnr4":
                  this.infoZYZF[3].content3 = el.Content;
                  break;
                case "cgzbg_zyzfbt5":
                  this.infoZYZF[4].title4 = el.Content;
                  break;
                case "cgzbg_zyzfnr5":
                  this.infoZYZF[4].content4 = el.Content;
                  break;
                case "cgzbg_zyzfbt6":
                  this.infoZYZF[5].title5 = el.Content;
                  break;
                case "cgzbg_zyzfnr6":
                  this.infoZYZF[5].content5 = el.Content;
                  break;
                case "cgzbg_zyzfbt7":
                  this.infoZYZF[6].title6 = el.Content;
                  break;
                case "cgzbg_zyzfnr7":
                  this.infoZYZF[6].content6 = el.Content;
                  break;
                case "cgzbg_zyzf1tp1":
                  if (el.Content) {
                    this.fileListZF1.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf1tp2":
                  if (el.Content) {
                    this.fileListZF1.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf1tp3":
                  if (el.Content) {
                    this.fileListZF1.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf1tp4":
                  if (el.Content) {
                    this.fileListZF1.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf1tp5":
                  if (el.Content) {
                    this.fileListZF1.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf1tp6":
                  if (el.Content) {
                    this.fileListZF1.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf2tp1":
                  if (el.Content) {
                    this.fileListZF2.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf2tp2":
                  if (el.Content) {
                    this.fileListZF2.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf2tp3":
                  if (el.Content) {
                    this.fileListZF2.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf2tp4":
                  if (el.Content) {
                    this.fileListZF2.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf2tp5":
                  if (el.Content) {
                    this.fileListZF2.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf2tp6":
                  if (el.Content) {
                    this.fileListZF2.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf3tp1":
                  if (el.Content) {
                    this.fileListZF3.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf3tp2":
                  if (el.Content) {
                    this.fileListZF3.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf3tp3":
                  if (el.Content) {
                    this.fileListZF3.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf3tp4":
                  if (el.Content) {
                    this.fileListZF3.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf3tp5":
                  if (el.Content) {
                    this.fileListZF3.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf3tp6":
                  if (el.Content) {
                    this.fileListZF3.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf4tp1":
                  if (el.Content) {
                    this.fileListZF4.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf4tp2":
                  if (el.Content) {
                    this.fileListZF4.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf4tp3":
                  if (el.Content) {
                    this.fileListZF4.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf4tp4":
                  if (el.Content) {
                    this.fileListZF4.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf4tp5":
                  if (el.Content) {
                    this.fileListZF4.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf4tp6":
                  if (el.Content) {
                    this.fileListZF4.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf5tp1":
                  if (el.Content) {
                    this.fileListZF5.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf5tp2":
                  if (el.Content) {
                    this.fileListZF5.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf5tp3":
                  if (el.Content) {
                    this.fileListZF5.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf5tp4":
                  if (el.Content) {
                    this.fileListZF5.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf5tp5":
                  if (el.Content) {
                    this.fileListZF5.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf5tp6":
                  if (el.Content) {
                    this.fileListZF5.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf6tp1":
                  if (el.Content) {
                    this.fileListZF6.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf6tp2":
                  if (el.Content) {
                    this.fileListZF6.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf6tp3":
                  if (el.Content) {
                    this.fileListZF6.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf6tp4":
                  if (el.Content) {
                    this.fileListZF6.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf6tp5":
                  if (el.Content) {
                    this.fileListZF6.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf6tp6":
                  if (el.Content) {
                    this.fileListZF6.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf7tp1":
                  if (el.Content) {
                    this.fileListZF7.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf7tp2":
                  if (el.Content) {
                    this.fileListZF7.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf7tp3":
                  if (el.Content) {
                    this.fileListZF7.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf7tp4":
                  if (el.Content) {
                    this.fileListZF7.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf7tp5":
                  if (el.Content) {
                    this.fileListZF7.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_zyzf7tp6":
                  if (el.Content) {
                    this.fileListZF7.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_ssxgbt1":
                  this.infoSSXG[0].title0 = el.Content;
                  break;
                case "cgzbg_ssxgnr1":
                  this.infoSSXG[0].content0 = el.Content;
                  break;
                case "cgzbg_ssxgbt2":
                  this.infoSSXG[1].title1 = el.Content;
                  break;
                case "cgzbg_ssxgnr2":
                  this.infoSSXG[1].content1 = el.Content;
                  break;
                case "cgzbg_ssxgbt3":
                  this.infoSSXG[2].title2 = el.Content;
                  break;
                case "cgzbg_ssxgnr3":
                  this.infoSSXG[2].content2 = el.Content;
                  break;
                case "cgzbg_ssxgbt4":
                  this.infoSSXG[3].title3 = el.Content;
                  break;
                case "cgzbg_ssxgnr4":
                  this.infoSSXG[3].content3 = el.Content;
                  break;
                case "cgzbg_ssxgbt5":
                  this.infoSSXG[4].title4 = el.Content;
                  break;
                case "cgzbg_ssxgnr5":
                  this.infoSSXG[4].content4 = el.Content;
                  break;
                case "cgzbg_ssxg1tp1":
                  if (el.Content) {
                    this.fileListXG1.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_ssxg1tp2":
                  if (el.Content) {
                    this.fileListXG1.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_ssxg1tp3":
                  if (el.Content) {
                    this.fileListXG1.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_ssxg1tp4":
                  if (el.Content) {
                    this.fileListXG1.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_ssxg1tp5":
                  if (el.Content) {
                    this.fileListXG1.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_ssxg1tp6":
                  if (el.Content) {
                    this.fileListXG1.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_ssxg2tp1":
                  if (el.Content) {
                    this.fileListXG2.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_ssxg2tp2":
                  if (el.Content) {
                    this.fileListXG2.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_ssxg2tp3":
                  if (el.Content) {
                    this.fileListXG2.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_ssxg2tp4":
                  if (el.Content) {
                    this.fileListXG2.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_ssxg2tp5":
                  if (el.Content) {
                    this.fileListXG2.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_ssxg2tp6":
                  if (el.Content) {
                    this.fileListXG2.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_ssxg3tp1":
                  if (el.Content) {
                    this.fileListXG3.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_ssxg3tp2":
                  if (el.Content) {
                    this.fileListXG3.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_ssxg3tp3":
                  if (el.Content) {
                    this.fileListXG3.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_ssxg3tp4":
                  if (el.Content) {
                    this.fileListXG3.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_ssxg3tp5":
                  if (el.Content) {
                    this.fileListXG3.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_ssxg3tp6":
                  if (el.Content) {
                    this.fileListXG3.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_ssxg4tp1":
                  if (el.Content) {
                    this.fileListXG4.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_ssxg4tp2":
                  if (el.Content) {
                    this.fileListXG4.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_ssxg4tp3":
                  if (el.Content) {
                    this.fileListXG4.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_ssxg4tp4":
                  if (el.Content) {
                    this.fileListXG4.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_ssxg4tp5":
                  if (el.Content) {
                    this.fileListXG4.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_ssxg4tp6":
                  if (el.Content) {
                    this.fileListXG4.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_ssxg5tp1":
                  if (el.Content) {
                    this.fileListXG5.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_ssxg5tp2":
                  if (el.Content) {
                    this.fileListXG5.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_ssxg5tp3":
                  if (el.Content) {
                    this.fileListXG5.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_ssxg5tp4":
                  if (el.Content) {
                    this.fileListXG5.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_ssxg5tp5":
                  if (el.Content) {
                    this.fileListXG5.push(this.toObj2("url", el.Content));
                  }
                  break;
                case "cgzbg_ssxg5tp6":
                  if (el.Content) {
                    this.fileListXG5.push(this.toObj2("url", el.Content));
                  }
                  break;
              }
            });
          } else if (res.data.code == 10002) {
            this.$message({
              type: "warning",
              message: res.data.msg,
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    next() {
      //存数据到数据库
      switch (this.NavI) {
        case 0:
          if (
            this.cggy.replace(/<[^>]+>/g, "").replace(/&nbsp;/gi, "").length >
            500
          ) {
            this.$message({
              message: "输入的字数超过规定字数",
              type: "warning",
            });
            return;
          } else {
            // this.cggy=""
            this.addcontent("cgzbg_cggy", this.cggy);
          }
          break;
        case 1:
          // console.log(this.qyjj.replace(/<.*?>/g,"").length,'qyLen')
          // this.addcontent('cgzbg_qyjj',this.qyjj);
          console.log(this.qyjj);
          if (this.qyjj) {
            console.log('第一个if');
            if (
              console.log('第2个if'),
              this.qyjj.replace(/<[^>]+>/g, "").replace(/&nbsp;/gi, "").length >
              500
            ) {
              this.$message({
                message: "输入的字数超过规定字数",
                type: "warning",
              });
              return;
            }
            else {
              // this.qyjj=""
              console.log(this.qyjj, "qyjj");
              this.addcontent("cgzbg_qyjj", this.qyjj);
            }
          } else {
            console.log('第一个else');
            this.addcontent("cgzbg_qyjj", this.qyjj);
          }
          break; //企业简介
        case 2:
          var ssbjLen =
            this.infoSSBJ[0].content0
              .replace(/<[^>]+>/g, "")
              .replace(/&nbsp;/gi, "").length +
            this.infoSSBJ[1].content1
              .replace(/<[^>]+>/g, "")
              .replace(/&nbsp;/gi, "").length +
            this.infoSSBJ[2].content2
              .replace(/<[^>]+>/g, "")
              .replace(/&nbsp;/gi, "").length;
          if (ssbjLen > 4000) {
            this.$message({
              message: "输入的字数超过规定字数",
              type: "warning",
            });
            return;
          } else {
            console.log(this.infoSSBJ, "bj");
            // this.infoSSBJ[0].content0=""
            // this.infoSSBJ[1].content1=""
            // this.infoSSBJ[2].content2=""
            this.addcontent("cgzbg_ssbjbt1", this.infoSSBJ[0].title0);
            this.addcontent("cgzbg_ssbjnr1", this.infoSSBJ[0].content0);
            this.addcontent("cgzbg_ssbjbt2", this.infoSSBJ[1].title1);
            this.addcontent("cgzbg_ssbjnr2", this.infoSSBJ[1].content1);
            this.addcontent("cgzbg_ssbjbt3", this.infoSSBJ[2].title2);
            this.addcontent("cgzbg_ssbjnr3", this.infoSSBJ[2].content2);
          }
          break;
        case 3:
          if (
            this.nh.replace(/<[^>]+>/g, "").replace(/&nbsp;/gi, "").length >
            1000
          ) {
            this.$message({
              message: "输入的字数超过规定字数",
              type: "warning",
            });
            return;
          } else {
            console.log(this.fileListNH);
            // this.nh=""
            this.addcontent("cgzbg_nh", this.nh);
            for (let i = 0; i < 6; i++) {
              this.addcontent("cgzbg_nhtp" + (i + 1), "");
            }
            this.fileListNH.forEach((data, index) => {
              if (data.url.split(":")[0] == "blob") {
                this.addcontent("cgzbg_nhtp" + (index + 1), data.response.data);
              } else {
                this.addcontent("cgzbg_nhtp" + (index + 1), data.url);
              }
            });
            console.log(this.fileListNH, "picnh");
          }
          break;
        case 4:
          var zyzfLen =
            this.infoZYZF[0].content0
              .replace(/<[^>]+>/g, "")
              .replace(/&nbsp;/gi, "").length +
            this.infoZYZF[1].content1
              .replace(/<[^>]+>/g, "")
              .replace(/&nbsp;/gi, "").length +
            this.infoZYZF[2].content2
              .replace(/<[^>]+>/g, "")
              .replace(/&nbsp;/gi, "").length;
          this.infoZYZF[3].content3
            .replace(/<[^>]+>/g, "")
            .replace(/&nbsp;/gi, "").length +
            this.infoZYZF[4].content4
              .replace(/<[^>]+>/g, "")
              .replace(/&nbsp;/gi, "").length +
            this.infoZYZF[5].content5
              .replace(/<[^>]+>/g, "")
              .replace(/&nbsp;/gi, "").length;
          this.infoZYZF[6].content6
            .replace(/<[^>]+>/g, "")
            .replace(/&nbsp;/gi, "").length;
          if (zyzfLen > 10000) {
            this.$message({
              message: "输入的字数超过规定字数",
              type: "warning",
            });
            return;
          } else {
            // this.infoZYZF[0].content0="";
            // this.infoZYZF[1].content1="";
            // this.infoZYZF[2].content2="";
            // this.infoZYZF[3].content3="";
            // this.infoZYZF[4].content4="";
            // this.infoZYZF[5].content5="";
            // this.infoZYZF[6].content6="";
            this.addcontent("cgzbg_zyzfbt1", this.infoZYZF[0].title0);
            this.addcontent("cgzbg_zyzfnr1", this.infoZYZF[0].content0);
            this.addcontent("cgzbg_zyzfbt2", this.infoZYZF[1].title1);
            this.addcontent("cgzbg_zyzfnr2", this.infoZYZF[1].content1);
            this.addcontent("cgzbg_zyzfbt3", this.infoZYZF[2].title2);
            this.addcontent("cgzbg_zyzfnr3", this.infoZYZF[2].content2);
            this.addcontent("cgzbg_zyzfbt4", this.infoZYZF[3].title3);
            this.addcontent("cgzbg_zyzfnr4", this.infoZYZF[3].content3);
            this.addcontent("cgzbg_zyzfbt5", this.infoZYZF[4].title4);
            this.addcontent("cgzbg_zyzfnr5", this.infoZYZF[4].content4);
            this.addcontent("cgzbg_zyzfbt6", this.infoZYZF[5].title5);
            this.addcontent("cgzbg_zyzfnr6", this.infoZYZF[5].content5);
            this.addcontent("cgzbg_zyzfbt7", this.infoZYZF[6].title6);
            this.addcontent("cgzbg_zyzfnr7", this.infoZYZF[6].content6);
            for (let i = 0; i < 6; i++) {
              this.addcontent("cgzbg_zyzf1tp" + (i + 1), "");
              console.log(i, 5555555);
            }
            for (let i = 0; i < 6; i++) {
              this.addcontent("cgzbg_zyzf2tp" + (i + 1), "");
            }
            for (let i = 0; i < 6; i++) {
              this.addcontent("cgzbg_zyzf3tp" + (i + 1), "");
            }
            for (let i = 0; i < 6; i++) {
              this.addcontent("cgzbg_zyzf4tp" + (i + 1), "");
            }
            for (let i = 0; i < 6; i++) {
              this.addcontent("cgzbg_zyzf5tp" + (i + 1), "");
            }
            for (let i = 0; i < 6; i++) {
              this.addcontent("cgzbg_zyzf6tp" + (i + 1), "");
            }
            for (let i = 0; i < 6; i++) {
              this.addcontent("cgzbg_zyzf7tp" + (i + 1), "");
            }
            console.log(this.fileListZF1, "zf1");
            this.fileListZF1.forEach((data, index) => {
              if (data.url.split(":")[0] == "blob") {
                this.addcontent(
                  "cgzbg_zyzf1tp" + (index + 1),
                  data.response.data
                );
              } else {
                this.addcontent("cgzbg_zyzf1tp" + (index + 1), data.url);
              }
              console.log(data, index);
            });
            this.fileListZF2.forEach((data, index) => {
              if (data.url.split(":")[0] == "blob") {
                this.addcontent(
                  "cgzbg_zyzf2tp" + (index + 1),
                  data.response.data
                );
              } else {
                this.addcontent("cgzbg_zyzf2tp" + (index + 1), data.url);
              }
            });
            this.fileListZF3.forEach((data, index) => {
              if (data.url.split(":")[0] == "blob") {
                this.addcontent(
                  "cgzbg_zyzf3tp" + (index + 1),
                  data.response.data
                );
              } else {
                this.addcontent("cgzbg_zyzf3tp" + (index + 1), data.url);
              }
            });
            this.fileListZF4.forEach((data, index) => {
              if (data.url.split(":")[0] == "blob") {
                this.addcontent(
                  "cgzbg_zyzf4tp" + (index + 1),
                  data.response.data
                );
              } else {
                this.addcontent("cgzbg_zyzf4tp" + (index + 1), data.url);
              }
            });
            this.fileListZF5.forEach((data, index) => {
              if (data.url.split(":")[0] == "blob") {
                this.addcontent(
                  "cgzbg_zyzf5tp" + (index + 1),
                  data.response.data
                );
              } else {
                this.addcontent("cgzbg_zyzf5tp" + (index + 1), data.url);
              }
            });
            this.fileListZF6.forEach((data, index) => {
              if (data.url.split(":")[0] == "blob") {
                this.addcontent(
                  "cgzbg_zyzf6tp" + (index + 1),
                  data.response.data
                );
              } else {
                this.addcontent("cgzbg_zyzf6tp" + (index + 1), data.url);
              }
            });
            this.fileListZF7.forEach((data, index) => {
              if (data.url.split(":")[0] == "blob") {
                this.addcontent(
                  "cgzbg_zyzf7tp" + (index + 1),
                  data.response.data
                );
              } else {
                this.addcontent("cgzbg_zyzf7tp" + (index + 1), data.url);
              }
            });
          }
          break;
        case 5:
          var ssxgLen =
            this.infoSSXG[0].content0
              .replace(/<[^>]+>/g, "")
              .replace(/&nbsp;/gi, "").length +
            this.infoSSXG[1].content1
              .replace(/<[^>]+>/g, "")
              .replace(/&nbsp;/gi, "").length +
            this.infoSSXG[2].content2
              .replace(/<[^>]+>/g, "")
              .replace(/&nbsp;/gi, "").length;
          this.infoSSXG[3].content3
            .replace(/<[^>]+>/g, "")
            .replace(/&nbsp;/gi, "").length +
            this.infoSSXG[4].content4
              .replace(/<[^>]+>/g, "")
              .replace(/&nbsp;/gi, "").length;
          if (ssxgLen > 3000) {
            this.$message({
              message: "输入的字数超过规定字数",
              type: "warning",
            });
            return;
          } else {
            // this.infoSSXG[0].content0="";
            // this.infoSSXG[1].content1="";
            // this.infoSSXG[2].content2="";
            // this.infoSSXG[3].content3="";
            // this.infoSSXG[4].content4="";
            this.addcontent("cgzbg_ssxgbt1", this.infoSSXG[0].title0);
            this.addcontent("cgzbg_ssxgnr1", this.infoSSXG[0].content0);
            this.addcontent("cgzbg_ssxgbt2", this.infoSSXG[1].title1);
            this.addcontent("cgzbg_ssxgnr2", this.infoSSXG[1].content1);
            this.addcontent("cgzbg_ssxgbt3", this.infoSSXG[2].title2);
            this.addcontent("cgzbg_ssxgnr3", this.infoSSXG[2].content2);
            this.addcontent("cgzbg_ssxgbt4", this.infoSSXG[3].title3);
            this.addcontent("cgzbg_ssxgnr4", this.infoSSXG[3].content3);
            this.addcontent("cgzbg_ssxgbt5", this.infoSSXG[4].title4);
            this.addcontent("cgzbg_ssxgnr5", this.infoSSXG[4].content4);
            for (let i = 0; i < 6; i++) {
              this.addcontent("cgzbg_ssxg1tp" + (i + 1), "");
            }
            for (let i = 0; i < 6; i++) {
              this.addcontent("cgzbg_ssxg2tp" + (i + 1), "");
            }
            for (let i = 0; i < 6; i++) {
              this.addcontent("cgzbg_ssxg3tp" + (i + 1), "");
            }
            for (let i = 0; i < 6; i++) {
              this.addcontent("cgzbg_ssxg4tp" + (i + 1), "");
            }
            for (let i = 0; i < 6; i++) {
              this.addcontent("cgzbg_ssxg5tp" + (i + 1), "");
            }
            this.fileListXG1.forEach((data, index) => {
              if (data.url.split(":")[0] == "blob") {
                this.addcontent(
                  "cgzbg_ssxg1tp" + (index + 1),
                  data.response.data
                );
              } else {
                this.addcontent("cgzbg_ssxg1tp" + (index + 1), data.url);
              }
            });
            this.fileListXG2.forEach((data, index) => {
              if (data.url.split(":")[0] == "blob") {
                this.addcontent(
                  "cgzbg_ssxg2tp" + (index + 1),
                  data.response.data
                );
              } else {
                this.addcontent("cgzbg_ssxg2tp" + (index + 1), data.url);
              }
            });
            this.fileListXG3.forEach((data, index) => {
              if (data.url.split(":")[0] == "blob") {
                this.addcontent(
                  "cgzbg_ssxg3tp" + (index + 1),
                  data.response.data
                );
              } else {
                this.addcontent("cgzbg_ssxg3tp" + (index + 1), data.url);
              }
            });
            this.fileListXG4.forEach((data, index) => {
              if (data.url.split(":")[0] == "blob") {
                this.addcontent(
                  "cgzbg_ssxg4tp" + (index + 1),
                  data.response.data
                );
              } else {
                this.addcontent("cgzbg_ssxg4tp" + (index + 1), data.url);
              }
            });
            this.fileListXG5.forEach((data, index) => {
              if (data.url.split(":")[0] == "blob") {
                this.addcontent(
                  "cgzbg_ssxg5tp" + (index + 1),
                  data.response.data
                );
              } else {
                this.addcontent("cgzbg_ssxg5tp" + (index + 1), data.url);
              }
            });
          }
          this.loading = true;
          break;
      }
      this.NavI = this.NavI + 1;
      console.log(this.NavI, "navi");
      scrollTo(0, 300);
    },
    up() {
      if (this.NavI > 0) {
        this.NavI = this.NavI - 1;
        scrollTo(0, 300);
      }
    },
    // 主报告上传
    upload() {
      this.$message({ message: "您的主报告已上传成功！", type: "success" });
      if (this.$route.query.ReportID) {
        this.$router.push("/Attachment?ReportID=" + this.$route.query.ReportID);
      } else {
        this.$router.push("/Attachment");
      }
    },
  },
};
</script>
<style lang="less">
#Report {
  .e {
    .text {
      min-height: 300px;
    }
  }
}
</style>
<style lang="less" scoped>
#Report {
  width: 100%;
  min-width: 1000px;

  .report {
    width: 100%;
    padding: 0 1.35rem;
    display: flex;
    align-items: stretch;
    margin-top: 0.4rem;

    .leftNav {
      padding-right: 0.4rem;
      border-right: 0.01rem solid #e4e4e4;
    }

    main {
      width: 100%;
      margin-left: 0.25rem;

      .edit {
        display: flex;
        justify-content: space-between;

        .textNav {
          width: 2rem;
          height: 9.5rem;

          .nTitle {
            width: 100%;
            height: 0.55rem;
            display: flex;
            align-items: center;
            background: #2d65d2;
            padding: 0.15rem;
            color: #ffffff;
          }

          ul {
            width: 100%;
            border: 0.01rem solid #949494;
            font-size: 0.17rem;
            height: calc(100% - 0.55rem);

            li {
              cursor: pointer;
              color: #949494;
              padding: 0.15rem;
              width: 100%;
              display: flex;
              align-items: center;

              &.active {
                color: #2d65d2;
              }
            }
          }
        }

        .container {
          width: 11rem;

          .content {
            margin-bottom: 0.5rem;

            .pic {
              margin: 0.3rem 0;

              p {
                margin-bottom: 0.1rem;
              }

              .img {
                margin-top: 0.2rem;

                img {
                  width: 2rem;
                  height: 2rem;
                }
              }
            }

            >p:nth-of-type(1) {
              font-size: 0.4rem;
              text-align: center;
              margin-bottom: 0.3rem;
            }

            .write {
              >p:nth-of-type(1) {
                color: red;
                margin-bottom: 0.1rem;
              }

              .info {
                div {
                  margin: 0.17rem 0;

                  input {
                    width: 4rem;
                    outline: 0;
                    padding: 0.06rem;
                  }

                  span {
                    width: 0.65rem;
                    height: 0.3rem;
                    line-height: 0.3rem;
                    text-align: center;
                    display: inline-block;
                    background: #409eff;
                    color: #fff;
                    cursor: pointer;
                    margin-left: 0.2rem;
                  }
                }
              }

              .button {
                width: 1rem;
                height: 0.4rem;
                line-height: 0.4rem;
                text-align: center;
                color: #fff;
                background: #2d65d2;
                cursor: pointer;
              }

              .del {
                background: #f70000;
              }
            }

            .ueditor {
              border: 1px solid #000;
            }

            .numbers {
              span {
                color: red;
              }
            }
          }

          .btn {
            width: 1.5rem;
            height: 0.4rem;
            line-height: 0.4rem;
            text-align: center;
            background: #2d65d2;
            color: #fff;
            cursor: pointer;
            float: right;
          }

          .btn1 {
            position: fixed;
            top: 77%;
            right: 1.35rem;
          }

          .btn1:nth-of-type(2) {
            right: 2.85rem;
          }

          .ts {
            font-size: 0.17rem;
            color: #aaa;
            float: right;
            margin: 0.1rem;
          }
        }
      }

      .pdf {
        min-height: 9rem;

        .preview {
          // min-height: 9rem;
          font-size: 0.25rem;
        }
      }
    }
  }
}
</style>